import { render, staticRenderFns } from "./common-btns.vue?vue&type=template&id=5e9c710c"
import script from "./common-btns.vue?vue&type=script&lang=js"
export * from "./common-btns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports